// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as BsCssJs$PrezzeeRibbon from "../../../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Responsive$PrezzeeRibbon from "../../../theme/Theme__Responsive.bs.js";

var ctaLine = BsCssJs$PrezzeeRibbon.style([
      BsCssJs$PrezzeeRibbon.display("inlineFlex"),
      BsCssJs$PrezzeeRibbon.flexWrap("wrap"),
      BsCssJs$PrezzeeRibbon.flexBasis(BsCssJs$PrezzeeRibbon.pct(100)),
      BsCssJs$PrezzeeRibbon.marginLeft(BsCssJs$PrezzeeRibbon.px(-12)),
      BsCssJs$PrezzeeRibbon.marginTop(BsCssJs$PrezzeeRibbon.px(-12)),
      BsCssJs$PrezzeeRibbon.media(Theme__Responsive$PrezzeeRibbon.smallScreenOrMobile, [BsCssJs$PrezzeeRibbon.width(BsCssJs$PrezzeeRibbon.pct(80))])
    ]);

var Styles = {
  ctaLine: ctaLine
};

function InnovativeWayToGift__CTA(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: ctaLine
            });
}

var make = InnovativeWayToGift__CTA;

export {
  Styles ,
  make ,
}
/* ctaLine Not a pure module */
